var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBankName(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 22.5V2.99998C21 1.34546 19.6545 0 18 0H6C4.34547 0 3.00001 1.34546 3.00001 2.99998V22.5H1.5V24H22.5V22.5H21V22.5ZM13.5 4.5H16.5V7.49998H13.5V4.5ZM13.5 8.99999H16.5V12H13.5V8.99999ZM13.5 13.5H16.5V16.5H13.5V13.5ZM7.50001 4.5H10.5V7.49998H7.50001V4.5ZM7.50001 8.99999H10.5V12H7.50001V8.99999ZM7.50001 13.5H10.5V16.5H7.50001V13.5ZM8.99998 22.5V18H15V22.5H8.99998Z",
    fill: "#4F565E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankName);
export default __webpack_public_path__ + "static/media/bank-name.7909b563d200e20e42ba3aff3732bb24.svg";
export { ForwardRef as ReactComponent };